<!--异步通知‘接收数据成功’接口-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "startTime": "20181022000000",
    "endTime": "20181022235959",
    "respTime": "20181022235959",
	"lockKey": "2420e3efbf6124c7185365b79c75c0f5be61a049",
	"syncStatus": 1,
	"syncStatusDesc": "接收成功"
           },
            responseCode: {"data": {
                },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台异步响应数据上报结果",
                t_url: this.commonUrls.test+"asynSuccess",
                p_url: this.commonUrls.prod+"asynSuccess",
                precondition: "上报失败数据产生超过15日后，平台将永久删除相关数据。",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '记录所在时间区间开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '记录所在时间区间结束时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'respTime', info2: '是', info3: 'String', info4: '响应时间, yyyyMMddHHmmss' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'syncStatus', info2: '是', info3: 'Integer', info4: '数据成功状态 0未上报，1上报中，2上报成功，3上报失败（建议使用2）' },
                        { info1: 'syncStatusDesc', info2: '是', info3: 'String', info4: '数据状态描述（建议使用：接收成功）' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
                      { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/asynSuccess.vue